import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { FaYoutube, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { LOGOMAIN } from '../../utils/helper';

function Footer() {
    const currentYear = new Date().getFullYear();
    
    const setting = {
        site_logo: LOGOMAIN,
        site_name: 'Kaanshi Films Entertainment',
        site_description: 'A Mumbai based Video & Film production house, where we deliver everything, from pre-production to post-production.',
        site_address: 'F- 604, Om Sai Heights - 2, Nalasopara west, Mumbai 401203',
        site_phone: '+91 9175612798',
        site_email: 'Info@kaanshifilms.com',
        site_copyright: 'Kaanshi Films Entertainment',
        developed_by: 'RDIGI WORKS',
        facebook: 'https://facebook.com/kaanshifilms',
        instagram: 'https://instagram.com/kaanshifilms',
        youtube: 'https://youtube.com/kaanshifilms',
        whatsapp: 'https://wa.me/919175612798',
        twitter: 'https://twitter.com/kaanshifilms',
        linkedin: 'https://linkedin.com/company/kaanshifilms',
    };

    const quickLinks = [
        { label: 'Home', path: '/' },
        { label: 'About', path: '/about' },
        { label: 'Services', path: '/services' },
        { label: 'Work', path: '/work' },
        { label: 'Profile', path: '/profile' },
        { label: 'Contact Us', path: '/contact' },
    ];

    const services = [
        { label: 'TV Commercials', path: '/services/tv-commercials' },
        { label: 'Digital Ads', path: '/services/digital-ads' },
        { label: 'Social Media Content', path: '/services/social-media-content' },
        { label: 'Corporate & Documentary ', path: '/services/corporate-films' },
        { label: 'Web Content', path: '/services/web-content' },
        { label: 'Training & Learning Videos', path: '/services/training-videos' },
        { label: 'Music Video', path: '/services/music-video' },
        { label: 'Branding Content', path: '/services/branding-content' },
        { label: 'Talk Shows', path: '/services/talk-shows' },
        { label: 'Promotional Videos', path: '/services/promotional-videos' },
        { label: 'Media Planning & Marketing', path: '/services/media-planning' },
        { label: 'Digital Marketing', path: '/services/digital-marketing' },
    ];

    const informationLinks = [
        { icon: <Phone size={18} />, text: setting.site_phone, link: `tel:${setting.site_phone}` },
        { icon: <Mail size={18} />, text: setting.site_email, link: `mailto:${setting.site_email}` },
        { icon: <MapPin size={18} />, text: setting.site_address, link: '#' },
    ];

    const socialLinks = [
        { icon: <Facebook size={20} />, url: setting.facebook, label: 'Facebook', color: 'hover:text-blue-600' },
        { icon: <Instagram size={20} />, url: setting.instagram, label: 'Instagram', color: 'hover:text-pink-600' },
        { icon: <FaYoutube size={20} />, url: setting.youtube, label: 'YouTube', color: 'hover:text-red-600' },
        { icon: <Twitter size={20} />, url: setting.twitter, label: 'Twitter', color: 'hover:text-blue-400' },
        { icon: <Linkedin size={20} />, url: setting.linkedin, label: 'LinkedIn', color: 'hover:text-blue-700' },
        { icon: <FaWhatsapp size={20} />, url: setting.whatsapp, label: 'WhatsApp', color: 'hover:text-green-600' },
    ];

    return (
        <footer className="bg-gradient-to-b from-green-950 to-gray-900 text-gray-300">
            <div className="max-w-7xl mx-auto px-4 py-12">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 mb-12 pb-12 border-b border-gray-800">
                    
                    <div className="lg:col-span-1 space-y-6">
                        <div className="space-y-4">
                            <div className="flex items-center gap-4">
                                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-amber-500/20">
                                    <img 
                                        src={setting.site_logo} 
                                        alt={setting.site_name} 
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold text-white mb-1">
                                        {setting.site_name.split(' ')[0]}
                                    </h2>
                                    <p className="text-sm text-gray-400">Films Entertainment</p>
                                </div>
                            </div>
                            <p className="text-gray-400 leading-relaxed text-sm">
                                {setting.site_description}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <h3 className="text-lg font-semibold text-white relative pb-3">
                            QUICK LINKS
                            <span className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full"></span>
                        </h3>
                        <ul className="space-y-3">
                            {quickLinks.map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-all duration-300 group"
                                    >
                                        <div className="w-1 h-1 bg-amber-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                        <span className="text-sm group-hover:translate-x-2 transition-transform duration-300">
                                            {link.label}
                                        </span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="space-y-6">
                        <h3 className="text-lg font-semibold text-white relative pb-3">
                            SERVICES
                            <span className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full"></span>
                        </h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {services.slice(0, 6).map((service, index) => (
                                <Link
                                    key={index}
                                    to={service.path}
                                    className="text-sm text-gray-400 hover:text-amber-400 transition-all duration-300 group flex items-center gap-2"
                                >
                                    <ArrowRight size={14} className="opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-amber-500" />
                                    <span className="group-hover:translate-x-1 transition-transform duration-300">
                                        {service.label}
                                    </span>
                                </Link>
                            ))}
                        </div>
                    </div>

                    <div className="space-y-6">
                        <h3 className="text-lg font-semibold text-white relative pb-3">
                            INFORMATION
                            <span className="absolute bottom-0 left-0 w-12 h-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full"></span>
                        </h3>
                        <ul className="space-y-4">
                            {informationLinks.map((info, index) => (
                                <li key={index} className="group">
                                    <a
                                        href={info.link}
                                        className="flex items-start gap-3 text-gray-400 hover:text-white transition-colors duration-300"
                                    >
                                        <div className="p-2 bg-gray-800/50 rounded-lg group-hover:bg-amber-500/20 transition-all duration-300">
                                            <div className="text-amber-500">{info.icon}</div>
                                        </div>
                                        <span className="text-sm leading-snug pt-2">{info.text}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center gap-6">
                        {socialLinks.map((social, index) => (
                            <a
                                key={index}
                                href={social.url}
                                aria-label={social.label}
                                className={`text-gray-400 ${social.color} transition-all duration-300 hover:scale-110`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {social.icon}
                            </a>
                        ))}
                    </div>

                    <div className="text-center md:text-left">
                        <p className="text-sm text-gray-500">
                            © {currentYear} <span className="text-amber-400 font-medium">{setting.site_copyright}</span>. All rights reserved.
                        </p>
                        
                        <p className="text-xs bg-white font-semibold px-3 py-1 rounded-full text-gray-600 mt-1">
                            Crafted with ❤️ by <a href="https://rdigiworks.com" className="text-amber-500 hover:text-amber-400 transition-colors">{setting.developed_by}</a>
                        </p>
                    </div>

                    <div className="flex items-center gap-6">
                        <Link
                            to="/privacy-policy"
                            className="text-sm text-gray-400 hover:text-amber-400 transition-colors duration-300"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/terms-conditions"
                            className="text-sm text-gray-400 hover:text-amber-400 transition-colors duration-300"
                        >
                            Terms & Conditions
                        </Link>
                    </div>
                </div>

                <div className="mt-10 pt-8 border-t border-green-800 hidden md:block">
                    <h4 className="text-center text-gray-400 text-sm font-semibold mb-6">Our Complete Service Portfolio</h4>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
                        {services.map((service, index) => (
                            <div
                                key={index}
                                className="group relative overflow-hidden rounded-lg bg-green-900/50 p-4 hover:bg-gray-800/50 transition-all duration-300 cursor-pointer"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-amber-500/10 to-orange-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <p className="text-xs text-gray-400 group-hover:text-amber-400 relative z-10 transition-colors duration-300">
                                    {service.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;